import React from "react";

const Table = ({ data }) => {
  if (data.length === 0) {
    return <p>No data available.</p>;
  }

  return (
    <div className="overflow-x-auto p-4">
      <table className="min-w-full border border-gray-300">
        <thead>
          <tr className="bg-gray-200">
            <th className="border p-2">Name</th>
            <th className="border p-2">Value</th>
            <th className="border p-2">Timestamp</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index} className="border">
              <td className="border p-2">{item.name}</td>
              <td className="border p-2">{item.value}</td>
              <td className="border p-2">{item.timestamp}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
